import { useEffect } from 'react'

export function useAiAskBarPrefillEffect({
  prefill,
  setComposerPlainText,
  setIsSendPulsing,
  connectContextRef,
  composerEditorRef,
}) {
  const prefillText = prefill?.text ?? ''
  const prefillNonce = prefill?.nonce ?? null

  useEffect(() => {
    if (prefillNonce === null || prefillNonce === undefined) return
    connectContextRef.current = prefill?.connectContext ?? null
    queueMicrotask(() => {
      setComposerPlainText(prefillText)
      setIsSendPulsing(true)
    })

    const focusFrame = window.requestAnimationFrame(() => {
      composerEditorRef.current?.setPlainContent(prefillText)
      composerEditorRef.current?.focusEnd()
    })
    const pulseTimer = window.setTimeout(() => setIsSendPulsing(false), 1200)

    return () => {
      window.cancelAnimationFrame(focusFrame)
      window.clearTimeout(pulseTimer)
    }
  }, [prefillNonce, prefillText, prefill, connectContextRef, composerEditorRef, setComposerPlainText, setIsSendPulsing])

  return { prefillText, prefillNonce }
}
